export default "__VITE_ASSET__CX_VjfdX__"